import React from 'react';
import { shape, bool, instanceOf, func, string } from 'prop-types';
// import DECheckbox from '../../shared/DECheckbox';
import TableHeaderButton from '../../shared/TableHeaderButton';
import {
  CAMPAIGN_TARGETS,
  SAMPLE_LABEL,
  WEIGHTED_HEADER_LABEL,
  PERCENT,
  LAST_MODIFIED,
} from '../../shared/DEConstants';
// import { _getCheckedDefination } from '../../../../util/deUtils';

const CTTableHead = ({ definition, updateQueryParams }) => {
  const sortBy = definition.query.sortBy;
  let sortOrder = definition.query.sortOrder;

  const onClick = (label, newSortBy) => {
    if (sortBy === newSortBy) {
      sortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    updateQueryParams(
      {
        sortBy: newSortBy,
        sortOrder,
      },
      'sort'
    );
  };

  let isDisabled = true;
  // const activeDefination = _getCheckedDefination(definition.data, 'isActive');
  if (definition.data.length > 0) {
    isDisabled = false;
  }

  // toggle this flag when multiple table multiple selection happen
  // let isIndeterminate = false;
  // let isChecked = false;
  // if (activeDefination.length > 0) {
    // isIndeterminate = true;
    // isChecked = true;
    // if (activeDefination.length === definition.data.length) {
    //   isIndeterminate = false;
    // }
  // }

  // const _handleSelectAll = checkSate => {
  //   setSelectedTargets(checkSate, null, true);
  // };

  return (
    <div className="de--table__head">
      <div className="de--table__row">
        {/* <div className="de--table__col ct--col__select">
          <DECheckbox
            onChange={_handleSelectAll}
            id="ct_select_all"
            isChecked={isChecked}
            data={{ all: true }}
            disabled={isDisabled}
            indeterminate={isIndeterminate}
          />
        </div> */}

        <div className="de--table__col ct--col__ct">
          <TableHeaderButton
            label={CAMPAIGN_TARGETS}
            isDisabled={isDisabled}
            sortBy="target"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortBy === 'target'}
          />
        </div>

        <div className="de--table__col ct--col__sample">
          <TableHeaderButton
            label={SAMPLE_LABEL}
            isDisabled={isDisabled}
            sortBy="sample"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortBy === 'sample'}
          />
        </div>

        <div className="de--table__col ct--col__wgth">
          <TableHeaderButton
            label={WEIGHTED_HEADER_LABEL}
            isDisabled={isDisabled}
            sortBy="weighted"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortBy === 'weighted'}
          />
        </div>

        <div className="de--table__col ct--col__per">
          <TableHeaderButton
            label={PERCENT}
            isDisabled={isDisabled}
            sortBy="perc"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortBy === 'perc'}
          />
        </div>

        <div className="de--table__col ct--col__lmodified">
          <TableHeaderButton
            label={LAST_MODIFIED}
            isDisabled={isDisabled}
            sortBy="updts"
            sortOrder={sortOrder}
            onClick={onClick}
            isActive={sortBy === 'updts'}
          />
        </div>
        <div className="de--table__col ct--col__actions">
          &nbsp;
        </div>
      </div>
    </div>
  );
};

CTTableHead.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
    query: shape({
      sortBy: string,
      sortOrder: string,
    }),
  }),
  updateQueryParams: func,
};

CTTableHead.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
    query: {
      sortBy: 'updts',
      sortOrder: 'desc',
    },
  },
};

export default CTTableHead;
